{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPIGroup} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/numberfield';
import statelyDocs from 'docs:@react-stately/numberfield';
import Anatomy from '/packages/dev/s2-docs/pages/react-aria/NumberFieldAnatomy.svg';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a number field component.';
export const isSubpage = true;

# useNumberField

<PageDescription>{docs.exports.useNumberField.description}</PageDescription>

```tsx render files={["starters/hooks/src/NumberField.tsx", "starters/hooks/src/NumberField.css", "starters/hooks/src/Button.css", "starters/hooks/src/Form.css"]}
"use client";
import {NumberField} from 'hooks-starter/NumberField';

<NumberField label="Price" defaultValue={6} formatOptions={{style: 'currency', currency: 'USD'}} />
```

## API

<Anatomy />

```tsx
<NumberField>
  <Label />
  <Group>
    <Input />
    <Button slot="increment" />
    <Button slot="decrement" />
  </Group>
  <Text slot="description" />
  <FieldError />
</NumberField>
```

<FunctionAPIGroup
  functions={[
    {function: statelyDocs.exports.useNumberFieldState, links: statelyDocs.links},
    {function: docs.exports.useNumberField, links: docs.links},
  ]}
/>

### NumberFieldState

<InterfaceType {...statelyDocs.exports.NumberFieldState} links={statelyDocs.links} />

### AriaNumberFieldProps

<InterfaceType {...docs.exports.AriaNumberFieldProps} />

### NumberFieldAria

<InterfaceType {...docs.exports.NumberFieldAria} />
